import { Component, OnInit, ViewChild } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { DxChartComponent, DxDataGridComponent } from 'devextreme-angular';
import { GlobalConstants } from 'src/app/common/global-constants';
import { UtilsService } from 'src/app/services/utils.service';
import { MRPService } from '../mrp.service';
import { AutocompleteComponent } from 'src/app/widgets/autocomplete/autocomplete.component';
import { Task, TaskService } from '../../task/task.service';
import { Location } from '@angular/common';
import { NavigateAssociates } from 'src/app/helpers/navigate-associates';
import { SettingsService } from '../../settings/settings.service';
import DataSource, { Options } from 'devextreme/data/data_source';
import { FileExportService } from 'src/app/common/file-export-service';
import { DevTooltipCustComponent } from 'src/app/widgets';
import { ShareDataService } from 'src/app/services/share-data.service';
import { BookmarkData } from 'src/app/models/Bookmark';
import { NotificationService } from 'src/app/services/notification.service';
import { TableParameterService } from 'src/app/services/table-parameter-service';
import { DxDataGridOperator } from 'src/app/operators/dx-data-grid.operator';
import { UserService } from 'src/app/services/user.service';
import { UserBasic } from '../../settings/user/models/user-basic.model';

@Component({
    selector: 'app-mrp-deepdive',
    templateUrl: './deepdive.component.html',
    styleUrls: ['./deepdive.component.scss'],
    standalone: false
})
export class DeepdiveComponent implements OnInit {

	constructor(
		private mrpService: MRPService,
		private _userService: UserService,
		private route: ActivatedRoute,
		private titleService: Title,
		private location: Location,
		private taskService: TaskService,
		private navigates: NavigateAssociates,
		private shareDataService: ShareDataService,
		private settingsService: SettingsService,
		private fileExportService: FileExportService,
		private notificationService: NotificationService,
		private tableParamService: TableParameterService
	) { this.shareDataService.CleanData(); }

	masterTableDataSource: any;
	DevelopmentChartSource: any;
	EsoObjectID: string;

	isBookmarkLoading = false;
	SecondHeaderName: string = "";
	//Auto Complete Variables
	autoCompleteProductDataSource: string[] = [];

	tableDetailedColumnsDataSource: any[] = [];
	tableDetailedValuesDataSource: any[] = [];
	tableGroupedColumnsDataSource: any[] = [];
	tableGroupedValuesDataSource: any[] = [];
	TableColumFormat: any[] = [];
	selectedItem = '';

	tableScopeColumnsDataSource: any[] = [];
	tableScopeValuesDataSource: any[] = [];


	visualRange: any = {};

	selectedEsoProduct = '';

	//MRP Action selection
	mrpActions: ListElement[] = [];
	selectedMrpAction: string;
	mrpActionComment: string = "";
	editingWasDone: boolean = false;
	lastUpdatedBy: UserBasic;
	lastUpdatedAt: string;


	infPopupTitle = '';
	showInfoPopup = false;
	infoPopupMessage = '';
	CurrcyCol = ["Stock", "InboundOrder", "InboundProposal", "RealizedBacklogCustomerOrder", "CustomerOrder", "CustomerOrderNotSupplied", "BacklogCustomerOrder", "RealizedBacklogForecast", "ForecastConsumed", "ForecastNotSupplied", "BacklogForecast", "SafetyStock"]

	@ViewChild('autocomplete')
	autocomplete: AutocompleteComponent;

	//dev express setting changes function for chart need on resize after windows size changes
	@ViewChild("DevelopmentChart", { static: false }) dxDevelopmentChart: DxChartComponent;
	@ViewChild('groupedDataGrid', { static: false }) dataGrid: DxDataGridComponent;
	@ViewChild('detailedDataGrid', { static: false }) dxEditingDetailedDataGrid: DxDataGridComponent;
	@ViewChild('scopeListDataGrid', { static: false }) dataScopeListGrid: DxDataGridComponent;

	scopeDatatypeValues = [];
	ngOnInit() {

		this.titleService.setTitle("MRP - DeepDive");
		this.route.paramMap.subscribe(
			params => {
				let value = null;
				if (this.route.snapshot.queryParamMap.get("id")) {
					value = this.route.snapshot.queryParamMap.get("id");
				}
				if (this.route.snapshot.queryParamMap.get("productId")) {
					value = this.route.snapshot.queryParamMap.get("productId");
				}
				this.EsoObjectID = (value != null && value != undefined ? value : null);
				this.selectedEsoProduct = this.EsoObjectID;
				this.LoadData('pageload');
				//binded using list data
				///this.LoadAutoCompleteData();
				this.getTasksForCurrentPage();
			});
		this.loadProductList();
		this.WebSettingsPivot();
		this.GetSettingsData();
		this.GetCaptions();
	}
	IsExportListEnable = false;
	GetSettingsData() {

		this.fileExportService.WebSettings("EnableExportMRPDeepDiveList").subscribe(resultFilename => {
			if (resultFilename && resultFilename.value) {
				this.IsExportListEnable = (resultFilename.value.toLowerCase() == "yes" ? true : false);
			}
		}, err => {
			console.log(err);
		});
	}

	captions: any = [];
	GetCaptions() {
		this.settingsService.SettingsGroupByName("SettingGroupName", encodeURIComponent("ESO Captions")).subscribe(result => {
			if (result != null && result.table != null) {
				this.captions = result.table;
				this.onResize();
			}
		}, err => {
			console.log(err);
		});
	}

	mrpActionChanged(e) {
		this.selectedMrpAction = e.itemData.listElement;
		this.editingWasDone = true;
	}

	commentChanged() {
		this.editingWasDone = true;
	}

	loadProductList() {
		this.mrpService.GetMrpDeepDiveTable("").subscribe(resp => {
			if (resp) {
				this.tableScopeColumnsDataSource = resp[0];
				this.tableScopeValuesDataSource = resp[1];
				this.autoCompleteProductDataSource = resp[0].map(product => product.productId = product.productId);
				this.dataFilter = new BookmarkData();
				this.dataFilter.BookmarkId = 0;
				this.dataFilter.name = "DefBokmk";
				this.dataFilter.pageName = this.pageName;
				this.addScopeDataTypeAndDataFormat();
				this.loadBookMarkFilter();
			}
		});
	}

	saveChanges() {
		this.mrpService.saveMrpActionChanges(this.selectedMrpAction, this.mrpActionComment, this.EsoObjectID).subscribe(res => {
			if (res) {
				this.notificationService.success('Changes saved successfully', 2000);
				this.editingWasDone = false;
				this._userService.getUserBasic(0).subscribe(res => {
					this.lastUpdatedBy = res;
				});
				this.lastUpdatedAt = new Intl.DateTimeFormat('en-US', {
					day: '2-digit',
					month: 'short',
					year: 'numeric',
					hour: '2-digit',
					minute: '2-digit',
					hour12: true,
				  }).format(new Date(Date.now()));
			}
		});
	}

	LoadData(action: string) {
		this.mrpService.getMrpActionsList().subscribe(res => {
			this.mrpActions = res;


			this.mrpService.GetMrpDeepDive(this.EsoObjectID).subscribe(res => {
				//convert received data to table structure for drop down

				if (res != null) {
					//chart data
					this.DevelopmentChartSource = res[0];
					//master table data
					if (res[1]) {
						//MRP Permanent Comment
						const commentEl = res[1].find(x => x.Name == "MrpPermanentComment");
						if (commentEl && commentEl.Value) {
							this.mrpActionComment = commentEl.Value;
						} else {
							this.mrpActionComment = '';
						}

						//MRP Action
						const actionEl = res[1].find(x => x.Name == "MrpAction");
						if (actionEl && actionEl.Value) {
							this.selectedMrpAction = actionEl.Value;
						} else {
							this.selectedMrpAction = null;
						}

						//Last updated date
						const updatedAt = res[1].find(x => x.Name == "MrpActionUpdateDate");
						if (updatedAt && updatedAt.Value) { this.lastUpdatedAt = updatedAt.Value; }

						//User data by id
						const userId = res[1].find(x => x.Name == "LastUpdatedByUserId");
						if (userId && userId.Value) {
							this._userService.getUserBasic(+userId.Value).subscribe(res => {
								this.lastUpdatedBy = res;
							});
						}
					}

					this.masterTableDataSource = res[1];
					//prodcut id
					if (res[2] != null && res[2].length > 0) {
						this.EsoObjectID = res[2][0].ProductId;
						if (res[2][0].SecondHeaderName) {
							this.SecondHeaderName = res[2][0].SecondHeaderName;
						}
					}

					//Grouped values
					this.tableGroupedColumnsDataSource = res[3];
					this.tableGroupedValuesDataSource = res[4];
					this.scopeDatatypeValues = [];
					if (res[7] != null) {
						this.TableColumFormat = res[7];
					}

					this.tableDetailedColumnsDataSource = res[5];
					this.tableDetailedValuesDataSource = res[6];


					if (this.TableColumFormat && this.TableColumFormat.length > 0) {
						this.TableColumFormat.forEach(itemCap => {
							//PeriodGrouped
							if (itemCap.Name == "PeriodGrouped") {
								this.tableGroupedColumnsDataSource.forEach(colName => {
									if (itemCap.SelectionName && colName.ColumnName && itemCap.SelectionName.toLocaleLowerCase() == colName.ColumnName.toLocaleLowerCase()) {
										if (colName.ColumnName.toLocaleLowerCase() == 'forecast') {
											colName.DataFormate = this.currcyFormat(2);
										}
										if (itemCap.DataTypeFormat) {
											colName.DataFormate = itemCap.DataTypeFormat;
										}
										if (itemCap.DataType) {
											colName.dataType = itemCap.DataType;
										}
									}
								});
							}
							//Detailed
							if (itemCap.Name == "Detailed") {
								this.tableDetailedColumnsDataSource.forEach(colName => {
									if (itemCap.SelectionName && colName.ColumnName && itemCap.SelectionName.toLocaleLowerCase() == colName.ColumnName.toLocaleLowerCase()) {
										if (colName.ColumnName.toLocaleLowerCase() == 'forecast') {
											colName.DataFormate = this.currcyFormat(2);
										}
										if (itemCap.DataTypeFormat) {
											colName.DataFormate = itemCap.DataTypeFormat;
										}
										if (itemCap.DataType) {
											colName.dataType = itemCap.DataType;
										}
									}
								});
							}
							//Master Table
							if (itemCap.Name == "MasterTable") {
								this.masterTableDataSource.forEach(colName => {
									if (itemCap.SelectionName && colName.Name && itemCap.SelectionName.toLocaleLowerCase() == colName.Name.toLocaleLowerCase()) {

										if (itemCap.DataTypeFormat) {
											colName.DataFormate = itemCap.DataTypeFormat;
										}
										if (itemCap.DataType) {
											colName.dataType = itemCap.DataType;
										}
									}
								});
							}
							if (itemCap.Name == "DeepDiveScope") {
								this.scopeDatatypeValues.push(itemCap);
							}
						});
					}
					this.addScopeDataTypeAndDataFormat();
					this.selectedItem = this.EsoObjectID;

					if (action == 'pageload') {
						this.location.go(`mrp/deepdive?id=${UtilsService.getURLHelper(this.EsoObjectID)}`);
					}
				}

			}, err => {
				console.log(err)

			},
				() => {

				}
			);
		});
	}
	addScopeDataTypeAndDataFormat() {
		if (this.tableScopeValuesDataSource && this.scopeDatatypeValues && this.scopeDatatypeValues.length > 0) {
			this.scopeDatatypeValues.forEach(itemCap => {
				this.tableScopeValuesDataSource.forEach(colName => {
					if (itemCap.SelectionName && colName.Caption && itemCap.SelectionName.toLocaleLowerCase() == colName.Caption.toLocaleLowerCase()) {
						if (itemCap.DataTypeFormat) {
							colName.DataFormate = itemCap.DataTypeFormat;
						}
						if (itemCap.DataType) {
							colName.dataType = itemCap.DataType;
						}
					}
				});
			});
		}
	}

	currcyFormat = function (RoundOffNumber) {
		return UtilsService.CurrcyFormat(RoundOffNumber);
	}
	//#region Chart Settings and funcation

	//adding customize setting with title, change title if need.
	customizeTooltip = (info: any) => {
		return DevTooltipCustComponent.customizeTooltip(info, "", "", "");
	}

	//adding percentage symbol in seasonality
	customizeText = (info: any) => {
		return Math.round(info.value).toLocaleString() + '%';
	}


	//hide and show series on click
	onLegendClickMainChart(e: any) {
		const series = e.target;
		let ShowHide = false;
		if (series.isVisible()) {
			series.hide();
		} else {
			series.show();
			
		}
		this.loadLengendToShare();
	}

	//hide and show series on click
	onLegendClick(e: any) {
		const series = e.target;
		if (series.isVisible()) {
			series.hide();
		} else {
			series.show();
		}
		this.loadLengendToShare();
	}
	//#endregion

	//window resize function  refresh all charts
	onResize() {
		setTimeout(() => {
			try {
				//caption
				for (let itemCaption = 0; itemCaption < this.captions.length; itemCaption++) {
					if (this.dxDevelopmentChart != null && this.dxDevelopmentChart.series != null && Array.isArray(this.dxDevelopmentChart.series)
						&& this.dxDevelopmentChart.series.length > 0) {
						for (let index = 0; index < this.dxDevelopmentChart.series.length; index++) {

							if (this.dxDevelopmentChart.series[index].valueField != null
								&& (this.dxDevelopmentChart.series[index].valueField.toLowerCase() == this.captions[itemCaption].name.toLowerCase()
									|| this.dxDevelopmentChart.series[index].name.toLowerCase() == this.captions[itemCaption].name.toLowerCase())

							) {
								this.dxDevelopmentChart.series[index].name = this.captions[itemCaption].value;
							}
						}
					}
				}
			}
			catch (e: unknown) { }
			if (this.dxDevelopmentChart) { this.dxDevelopmentChart.instance.refresh(); }
		});
	}

	getMarkerPath(item) {
		
		return UtilsService.getlegendMarkerPathDynamic(item, 'deepdive', GlobalConstants.SvgLinSettingsCollection.defaultSettingsNew);
	}

	LoadAutoCompleteData() {
		this.mrpService.GetMrpDeepDiveAutoComplete().subscribe(res => {
			//convert received data to table structure for drop down
			// this.autoCompleteProductDataSource = res.autoLst.map(product => product.productId = product.productId);
		}, err => {
			console.log(err)

		},
			() => {

			}
		);
	}


	onToolbarPreparing(e) {
		const toolbarItems = e.toolbarOptions.items;
		toolbarItems.unshift({
			location: 'after',
			template: 'appliedFiltersButtonTemplate'
		}, {
			location: 'before',
			template: 'expandButtonTemplate'
		}, {
			location: 'before',
			template: 'heightButtonTemplate'
		});
	}

	fitTableToPage = false;
	anyActiveFilters = false;
	changeActiveFiltersStatus() {
		if (this.anyActiveFilters) {
			this.anyActiveFilters = !this.anyActiveFilters;
			this.dataGrid.instance.clearFilter();
			this.Grouped = [];
			this.ChartSettings.Grouped = [];
		}
	}

	fitTableToPageDetailed = false;
	anyActiveFiltersDetailed = false;
	changeActiveFiltersDetailedStatus() {
		if (this.anyActiveFiltersDetailed) {
			this.anyActiveFiltersDetailed = !this.anyActiveFiltersDetailed;
			this.dxEditingDetailedDataGrid.instance.clearFilter();
			this.Detailed = [];
			this.ChartSettings.Detailed = [];
		}
	}

	public dxDataGridOperatorDetailed: DxDataGridOperator = new DxDataGridOperator();

	public onDataGridContentReadyDetailed(evt) {
		const curFilter = evt.component.getCombinedFilter();
		if (curFilter) {
			this.anyActiveFiltersDetailed = true;
		} else {
			this.anyActiveFiltersDetailed = false;
		}

		this.dxDataGridOperatorDetailed.updateRowCount(evt.component);

		localStorage.setItem('grid-state-mrp-deep-detailed', JSON.stringify(this.dxEditingDetailedDataGrid.instance.state()));
	}

	changeFitToPageStatusDetailed() {
		this.fitTableToPageDetailed = !this.fitTableToPageDetailed;
	}

	public dxDataGridOperator: DxDataGridOperator = new DxDataGridOperator();

	public onDataGridContentReady(evt) {
		const filter = evt.component.getCombinedFilter();
		if (filter) {
			this.anyActiveFilters = true;
		} else {
			this.anyActiveFilters = false;
		}

		this.dxDataGridOperator.updateRowCount(evt.component);

		localStorage.setItem('grid-state-mrp-deep-editing', JSON.stringify(this.dataGrid.instance.state()));
	}

	changesFitToPageStatus() {
		this.fitTableToPage = !this.fitTableToPage;
		

		let currentState = this.dataGrid.instance.state();
		currentState.columns.forEach(col => {
			delete col.width;
		});

		this.dataGrid.instance.state(currentState);
	}

	changeFitToPageDataGridStatus() {
		this.fitTableToPageDetailed = !this.fitTableToPageDetailed;
		

		let currentState = this.dxEditingDetailedDataGrid.instance.state();
		currentState.columns.forEach(col => {
			delete col.width;
		});

		this.dxEditingDetailedDataGrid.instance.state(currentState);
	}

	// Task data
	tasks: Task[] = [];
	showTasksPopup = false;
	showAddTaskPopup = false;
	currentUrl = '';
	activeTasksForCurrentPage = false;
	activeTasks: Task[] = [];

	private getTasksForCurrentPage() {
		this.taskService.getTasksForUrl(this.location.path()).subscribe(result => {
			this.tasks = result;
			if (this.tasks.length > 0) {
				this.activeTasksForCurrentPage = true;
			} else {
				this.activeTasksForCurrentPage = false;
			}
		});
	}

	showTasksForCurrentUrl() {
		this.getTasksForCurrentPage();
		this.currentUrl = this.location.path();

		if (this.tasks.length > 0) {
			this.showTasksPopup = true;
		} else {
			this.showAddTaskPopup = true;
		}
	}

	onDataGridCellPrepared(e) {
		e.cellElement.style.padding = '5px';
	}

	getProductData(item?: any) {
		if (item) {
			this.lastUpdatedBy = null;
			this.lastUpdatedAt = null;
			this.EsoObjectID = item ? item : '';
			this.selectedEsoProduct = this.EsoObjectID;
			this.location.go(`mrp/deepdive?id=${UtilsService.getURLHelper(item)}`);

			this.LoadData('reload');

			setTimeout(() => this.autocomplete.setSelectedItem(item));

			this.scrollTop();
			this.getTasksForCurrentPage();
		}
	}

	scrollTop() {
		const el = document.getElementById('anchor');
		setTimeout(() => {
			if (el) { el.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
		}, 1);
	}

	changeInfoPopupStatus() {
		this.showInfoPopup = false;
		this.infoPopupMessage = '';
		this.infPopupTitle = '';
	}

	//scope table
	fitScopeTableToPage = false;
	changeFitToScopePageStatus() {
		this.fitScopeTableToPage = !this.fitScopeTableToPage;
		

		let currentState = this.dataScopeListGrid.instance.state();
		currentState.columns.forEach(col => {
			delete col.width;
		});

		this.dataScopeListGrid.instance.state(currentState);
	}

	anyScopeTableActiveFilters = false;
	changeScopeTableActiveFiltersStatus() {
		if (this.anyScopeTableActiveFilters) {
			this.anyScopeTableActiveFilters = !this.anyScopeTableActiveFilters;
			this.dataScopeListGrid.instance.clearFilter();
			this.ScopeList = [];
			this.ChartSettings.ScopeList = [];
		}
	}

	public dxDataGridOperatorScope: DxDataGridOperator = new DxDataGridOperator();

	public onDataGridScopeTableContentReady(evt) {
		const curFilter = evt.component.getCombinedFilter();
		if (curFilter) {
			this.anyScopeTableActiveFilters = true;
		} else {
			this.anyScopeTableActiveFilters = false;
		}

		//creating new data source
		let gridData = new DataSource(
			<Options>
			{
				store: this.dataScopeListGrid.dataSource,
				paginate: false
			}
		);


		//Getting all Filtering
		let filterExpr = evt.component.getCombinedFilter();
		if (filterExpr != null) {
			gridData.filter(filterExpr);
		}

		//Getting all sorting
		let sortingExpres = evt.component.getDataSource().sort();
		if (sortingExpres != null) {
			gridData.sort(sortingExpres);
		}


		gridData.load().then((result) => {
			let data = result.map(product => product);
			this.autoCompleteProductDataSource = data.map(product => product.productId = product.productId);
		});

		this.dxDataGridOperatorScope.updateRowCount(evt.component);

		localStorage.setItem('grid-state-mrp-deep-scoped', JSON.stringify(this.dataScopeListGrid.instance.state()));
	}

	onToolbarScopeTablePreparing(e) {
		const toolbarItems = e.toolbarOptions.items;
		toolbarItems.unshift({
			location: 'after',
			template: 'appliedFiltersButtonTemplate'
		}, {
			location: 'before',
			template: 'expandButtonTemplate'
		}, {
			location: 'before',
			template: 'heightButtonTemplate'
		});
	}

	rowButtonClicked(e, item) {

		if (item != null) {
			let productId = item.data.productId ? item.data.productId : '';
			this.location.go(`mrp/deepdive?id=${UtilsService.getURLHelper(productId)}`);
			this.selectedEsoProduct = productId;
			this.EsoObjectID = productId;
			this.LoadData('reload');
			setTimeout(() => this.autocomplete.setSelectedItem(productId));
		}
		this.scrollTop();
		this.getTasksForCurrentPage();

	}

	//tooltip
	EnableTooltip = false;
	ShowTooltip = false;
	WebSettingsPivot() {
		this.fileExportService.WebSettingsPivot("actionpivotMrpDeepDive").subscribe(result => {

			if (result != null && result.length > 0 && result[0].defaultSelectionTooltipMrpDeepDive != null
				&& result[0].defaultSelectionTooltipMrpDeepDive.toLowerCase() == "yes") {
				this.EnableTooltip = true;
			}
			if (result != null && result.length > 0 && result[0].enableDisableTooltipMrpDeepDive != null
				&& result[0].enableDisableTooltipMrpDeepDive.toLowerCase() == "yes") {
				this.ShowTooltip = true;
			}

		}, err => {
			console.log(err);
		});
	}
	ScopeList = [];
	saveState = (statenew) => {
	
		this.ScopeList = [];
		if (statenew != null && statenew.columns != null && statenew.columns.length > 0) {
			statenew.columns.forEach(element => {
				if (element.filterValues) {
					this.ScopeList.push({
						fieldName: element.dataField, filterType: element.filterType,
						value: element.filterValues
					});
				}
			});
		}
		this.loadLengendToShare();
	}
	Detailed = [];
	saveDetailedState = (statenew) => {
		this.Detailed = [];
		if (statenew != null && statenew.columns != null && statenew.columns.length > 0) {
			statenew.columns.forEach(element => {
				if (element.filterValues) {
					this.Detailed.push({
						fieldName: element.dataField, filterType: element.filterType,
						value: element.filterValues
					});
				}
			});
		}
		this.loadLengendToShare();
	}
	Grouped = [];
	saveGroupedState = (state) => {
		this.Grouped = [];
		if (state != null && state.columns != null && state.columns.length > 0) {
			state.columns.forEach(element => {
				if (element.filterValues) {
					this.Grouped.push({
						fieldName: element.dataField, filterType: element.filterType,
						value: element.filterValues
					});
				}
			});
		}
		this.loadLengendToShare();
	}

	pageName: string = "MRPDeepDive";
	dataFilter: BookmarkData;

	loadBookMarkFilterClick(data) {
		if (data != null && data != undefined && data.bookmarkId != null && data.bookmarkId != undefined) {
			this.dataFilter = new BookmarkData();
			this.dataFilter.BookmarkId = data.bookmarkId;
			this.dataFilter.name = "Bokmk";
			this.dataFilter.pageName = this.pageName;
			this.loadBookMarkFilter();
		}
	}

	loadBookMarkFilter() {
		if (this.dataScopeListGrid != null && this.dataScopeListGrid.instance != null) {
			this.dataScopeListGrid.instance.clearFilter();
		}
		if (this.dataGrid != null && this.dataGrid.instance != null) {
			this.dataGrid.instance.clearFilter();
		}
		if (this.dxEditingDetailedDataGrid != null && this.dxEditingDetailedDataGrid.instance != null) {
			this.dxEditingDetailedDataGrid.instance.clearFilter();
		}
		this.isBookmarkLoading = true;
		let filterData = Object.assign({}, this.dataFilter);
		filterData.name = "BokmkN";
		this.ChartSettings = null;
		this.taskService.LoadBookmarkData(filterData).subscribe(RData => {
			if (RData != null && RData.table != null && RData.table.length > 0) {
				if (RData.table[0].chartSettings != null && RData.table[0].chartSettings != "") {
					this.ChartSettings = JSON.parse(RData.table[0].chartSettings);
				}
				this.isBookmarkLoading = false;
				this.LoadChartSeries();
				this.onResize();
				this.loadLengendToShare();
				this.taskService.LoadBookmarkFilter(this.dataFilter).subscribe(data => {
					data.forEach(element => {
						let ArrItem = JSON.parse(element.settingValue);
						if (ArrItem != null && ArrItem.length > 0) {
							this.dataScopeListGrid.instance.beginUpdate();
							this.dataScopeListGrid.instance.columnOption(element.fieldName, 'filterType', 'include');
							if (element.settingId != null && element.settingId != undefined) {
								if (element.settingId == -1) {
									this.dataScopeListGrid.instance.columnOption(element.fieldName, 'filterType', 'exclude');
								}
							}
							this.dataScopeListGrid.instance.columnOption(element.fieldName, 'filterValues', ArrItem);
							this.dataScopeListGrid.instance.endUpdate();
						}
					});
				}, err => {
				});
			}
			else {
				this.isBookmarkLoading = false;
			}
		}, err => {
		});


	}

	loadLengendToShare() {
		let seriesValues = { DevelopmentChart: [], Grouped: [], Detailed: [], ScopeList: [] };
		if (this.dxDevelopmentChart != null && this.dxDevelopmentChart.instance != null
			&& this.dxDevelopmentChart.instance.getAllSeries() != null) {
			this.dxDevelopmentChart.instance.getAllSeries().forEach(item => {
				if (item.name != null && item["getValueFields"]() && item["getValueFields"]().length > 0) {
					seriesValues.DevelopmentChart.push({ ValueField: item["getValueFields"]()[0], Name: item.name, isVisible: item.isVisible() });
				}
			})
		}
		seriesValues.Detailed = this.Detailed;
		seriesValues.Grouped = this.Grouped;
		seriesValues.ScopeList = this.ScopeList;
		this.shareDataService.ChartSettings = JSON.stringify(seriesValues);
	}

	ChartSettings: any;
	LoadChartSeries() {
		if (this.dxDevelopmentChart != null && this.dxDevelopmentChart.series != null
			&& Array.isArray(this.dxDevelopmentChart.series) && this.dxDevelopmentChart.series.length > 0) {
			for (let index = 0; index < this.dxDevelopmentChart.series.length; index++) {
				this.dxDevelopmentChart.series[index].visible = true;
			}
		}
		if (this.ChartSettings != null) {
			if (this.ChartSettings.DevelopmentChart != null && this.ChartSettings.DevelopmentChart.length > 0 && Array.isArray(this.dxDevelopmentChart.series)) {
				if (this.dxDevelopmentChart != null && this.dxDevelopmentChart.series != null
					&& this.dxDevelopmentChart.series.length > 0) {
					for (let index = 0; index < this.dxDevelopmentChart.series.length; index++) {
						this.ChartSettings.DevelopmentChart.forEach(itemchrt => {
							if (this.dxDevelopmentChart.series[index].valueField != null
								&& itemchrt.isVisible != null && (this.dxDevelopmentChart.series[index].valueField.toLowerCase() == itemchrt.ValueField.toLowerCase()
									|| this.dxDevelopmentChart.series[index].name.toLowerCase() == itemchrt.ValueField.toLowerCase())
							) {
								this.dxDevelopmentChart.series[index].visible = itemchrt.isVisible;
							}
						});
					}
				}
			}
			if (this.ChartSettings.Grouped != null && this.ChartSettings.Grouped.length > 0) {
				if (this.dataGrid != null && this.dataGrid.instance != null) {
					this.ChartSettings.Grouped.forEach(element => {
						this.dataGrid.instance.beginUpdate();
						this.dataGrid.instance.columnOption(element.fieldName, 'filterType', 'include');
						if (element.filterType != null && element.filterType != undefined) {
							this.dataGrid.instance.columnOption(element.fieldName, 'filterType', element.filterType);
						}
						this.dataGrid.instance.columnOption(element.fieldName, 'filterValues', element.value);
						this.dataGrid.instance.endUpdate();
					});
				}
			}

			if (this.ChartSettings.Detailed != null && this.ChartSettings.Detailed.length > 0) {
				if (this.dxEditingDetailedDataGrid != null && this.dxEditingDetailedDataGrid.instance != null) {
					this.ChartSettings.Detailed.forEach(element => {
						this.dxEditingDetailedDataGrid.instance.beginUpdate();
						this.dxEditingDetailedDataGrid.instance.columnOption(element.fieldName, 'filterType', 'include');
						if (element.filterType != null && element.filterType != undefined) {
							this.dxEditingDetailedDataGrid.instance.columnOption(element.fieldName, 'filterType', element.filterType);
						}
						this.dxEditingDetailedDataGrid.instance.columnOption(element.fieldName, 'filterValues', element.value);
						this.dxEditingDetailedDataGrid.instance.endUpdate();
					});
				}
			}

			if (this.ChartSettings.ScopeList != null && this.ChartSettings.ScopeList.length > 0) {
				if (this.dataScopeListGrid != null && this.dataScopeListGrid.instance != null) {
					this.ChartSettings.ScopeList.forEach(element => {
						this.dataScopeListGrid.instance.beginUpdate();
						this.dataScopeListGrid.instance.columnOption(element.fieldName, 'filterType', 'include');
						if (element.filterType != null && element.filterType != undefined) {
							this.dataScopeListGrid.instance.columnOption(element.fieldName, 'filterType', element.filterType);
						}
						this.dataScopeListGrid.instance.columnOption(element.fieldName, 'filterValues', element.value);
						this.dataScopeListGrid.instance.endUpdate();
					});
				}
			}

			if (this.dxDevelopmentChart) { this.dxDevelopmentChart.instance.refresh(); }

		}
	}

	ConvertToFormat(item) {
		try {
			return UtilsService.ConvertToFormats(item.dataType, item.Value, item.DataFormate);
		}
		catch (e: unknown) {
			console.log("ConvertToFormat Error-", e);
		}
		return item.Value;
	}

}

export class ListElement {
	public listElementId: number;
	public listElement: string;
}
